import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import ReturnFileHeader from "../../components/ui/ReturnFileHeader";
import { useEffect, useState } from "react";
import axios from "../../api/axiosClient";
import { useLoading } from "../../components/LoadingContext";
import { errorToast, handleError } from "../../services/serviceBase";
import { Box, Button, Card, Grid, IconButton, Modal, Typography } from "@mui/material";
import AttachmentModal from "../../components/Modals/AttachmentModal";
import ExpandableCustomTable from "../../components/ui/ExpandableCustomTable";

import moment from "moment";
import AddModal from "../../components/Modals/CreditNote/AddModal";
import toast from "react-hot-toast";
import SizeAndQty from "../../components/ui/CreditNote/SizeAndQty";
import EditWarehouseDestinationsForRAList from "../../components/ui/CreditNote/EditWarehouseDestinationsForRAList";
import EditSizesAndQtyModal from "../../components/Modals/CreditNote/EditSizesAndQtyModal";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteIcon from '@mui/icons-material/Delete';
import AcceptModal from "../../components/Modals/CreditNote/AcceptModal";
import RADetailsThresholdMessage from "../../components/ui/CreditNote/RADetailsThresholdMessage";
import { useSelector } from "react-redux";
import useStreamState from "../../components/CustomHooks/useStreamState";
import * as apiService from "../../services/apiService";

const RAPreparing = () => {

  const modalStyle = {
    position: "relative",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    boxShadow: 24,
    width: 900,
    p: 4,
    borderRadius: "5px",
  };

  const intl = useIntl();
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  
  const params = useParams();
  const { idReturnFileHead } = params;

  const user = useSelector((state) => state.auth.user);

  const [detailsHeader, setDetailsHeader] = useState(null);
  const [details, setDetails] = useState([]);
  const [state, setState] = useState(null);

  const [boxInCount, setBoxInCount] = useState(null);
  const [isStealthFile, setIsStealthFile] = useState(false);

  const [openModalAttachments, setopenModalAttachments] = useState(false);
  const handleOpenModalAttachments = () => setopenModalAttachments(true);
  const handleCloseModalAttachments = () => setopenModalAttachments(false);

  //#region Add
  const [openModalAdd, setopenModalAdd] = useState(false);
  const handleOpenModalAdd = () => setopenModalAdd(true);
  const handleCloseModalAdd = () => {
    setopenModalAdd(false);    
    getDetails();
  }
  //#endregion

  //#region Accept
  const [openModalAccept, setOpenModalAccept] = useState(false);
  const handleOpenModalAccept = () => {
    if(details.length == 0){
      toast.error(intl.formatMessage({ id: "Error.NoRowsFound" }));
      return;
    }
    setOpenModalAccept(true)
  }
  const handleCloseModalAccept = () => setOpenModalAccept(false);
  //#endregion

  const [selectedRows, setSelectedRows] = useState([]);
  const [showRADetailsThresholdMessage, setShowRADetailsThresholdMessage] = useState(false);

  const [tableHeigth, setTableHeigth] = useState(600);
  const resizeTable = () => {
    var navigationHeaderHeight = document.querySelector("#navigationHeader")?.clientHeight;
    var headerHeight = document.querySelector("#header")?.clientHeight;
    var raDetailsThresholdMessageHeigth = document.querySelector("#RADetailsThresholdMessage")?.clientHeight ?? 0;
    var actionsHeight = document.querySelector("#actionsTop")?.clientHeight;
    var actionsBottomHeigth = document.querySelector("#actionsBottom")?.clientHeight;
    
    var pageHeight = window.innerHeight;
    var tableHeight = pageHeight - navigationHeaderHeight - headerHeight - raDetailsThresholdMessageHeigth - actionsHeight - actionsBottomHeigth - 60;
    setTableHeigth(tableHeight);
  };

  useEffect(() => {
      window.addEventListener("resize", resizeTable);
      return () => {
        window.removeEventListener("resize", resizeTable);
      };
    }, []);

  useEffect(() => {
    resizeTable();
    getDetails();
    getBoxInCount();
    getIsStealthReturnFile();
  }, []);

  const getDetails = () => {
    setLoading(true);
    axios
      .get("/creditnotereturnfiles/" + idReturnFileHead)
      .then((response) => {
        setLoading(false);
        setDetailsHeader(response.data.returnFileHeadInfo);
        setDetails(response.data.details);
        setState({
          rfState: response.data.returnFileHeadInfo.rfState,
          rfStateCode: response.data.returnFileHeadInfo.rfStateCode,
        });
        var groupedDetailsByStyleFabricColor = groupByStyleFabricColorArray(response.data.details);
        if(groupedDetailsByStyleFabricColor.length > 999){
          setShowRADetailsThresholdMessage(true);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  useEffect(() => {
    resizeTable();
  }, [showRADetailsThresholdMessage])

  function groupByStyleFabricColorArray(data) {
    const groupMap = new Map();
    
    data.forEach(item => {
      const key = `${item.styleCode}-${item.fabricCode}-${item.colorCode}`;
      
      if (!groupMap.has(key)) {
        groupMap.set(key, {
          styleCode: item.styleCode,
          fabricCode: item.fabricCode,
          colorCode: item.colorCode,
          skuDescription: item.skuDescription,
          items: []
        });
      }
      
      groupMap.get(key).items.push(item);
    });
    
    return Array.from(groupMap.values());
  }

  const handleChangeSelectedRowsOfTable = (value) => {
    setSelectedRows(value);
  }

  const columns = [
    {
      field: "idInvoiceRow",
      className: "grid-header apeLigthBlueBackground",
      width: 100,
      renderHeader: () => "",
      renderCell: (params) => {
        if (params.row.idInvoiceHeader != null) {
          return (
            <IconButton
              onClick={(e) => {
                handleEdit(
                  params.row.idReturnFileRowList,
                  params.row.idInvoiceHeader,
                  params.row.invoiceRowNumber
                );
              }}
            >
              <ArrowForwardIosIcon size="small" />
            </IconButton>
          );
        } else {
          return "";
        }
      },
    },
    {
      field: "idInvoiceRow",
      className: "grid-header apeLigthBlueBackground",
      width: 100,
      renderHeader: () => "",
      renderCell: (params) => {
        if (detailsHeader != null && detailsHeader.rfSubType != "STH-FILE") {
          return (
            <IconButton
              onClick={(e) => {
                deleteRows(idReturnFileHead, params.row.idReturnFileRowList);
              }}
            >
              <DeleteIcon size="small" />
            </IconButton>
          );
        }
      },
    },
    {
      field: "idInvoiceRow",
      className: "grid-header apeLigthBlueBackground",
      width: 150,
      renderHeader: () => intl.formatMessage({ id: "Invoice.Nr" }),
      renderCell: (params) =>
        [
          params.row.invoiceYear,
          params.row.invoiceQualifier,
          params.row.invoiceNumber,
          params.row.invoiceRowNumber,
        ]
          .filter((part) => part != null && part !== "")
          .join("/"),
    },
    {
      field: "invoiceDate",
      className: "grid-header apeLigthBlueBackground",
      width: 200,
      renderHeader: () => intl.formatMessage({ id: "Invoice.Date" }),
      renderCell: (params) =>
        moment(params.row.invoiceDate).isValid()
          ? moment(params.row.invoiceDate).format("YYYY-MM-DD")
          : "",
    },
    {
      field: "customerInvoice",
      className: "grid-header apeLigthBlueBackground",
      width: 100,
      renderHeader: () => intl.formatMessage({ id: "General.Customer" }),
    },
    {
      field: "idSku",
      className: "grid-header apeLigthBlueBackground",
      width: 380,
      renderHeader: () => intl.formatMessage({ id: "Article.Article" }),
      renderCell: (params) =>
        params.row.styleCode +
        "-" +
        params.row.fabricCode +
        "-" +
        params.row.colorCode,
    },
    {
      field: "skuDescription",
      className: "grid-header apeLigthBlueBackground",
      width: 400,
      renderHeader: () => intl.formatMessage({ id: "General.Description" }),
    },
    {
      field: "unitPrice",
      className: "grid-header apeLigthBlueBackground",
      width: 180,
      renderHeader: () => intl.formatMessage({ id: "General.UnitPrice" }),
    },
    {
      field: "idInvoiceRow",
      className: "grid-header apeLigthBlueBackground",
      width: 150,
      renderHeader: () => intl.formatMessage({ id: "General.QuantityTot" }),
      renderCell: (params) =>
        params.row.sizeAndQuantities
          .map((x) => x.renderedQty)
          .reduce((acc, curr) => acc + curr, 0),
    },
    {
      field: "financialDiscount",
      className: "grid-header apeLigthBlueBackground",
      renderHeader: () => intl.formatMessage({ id: "General.Discount" }),
      renderCell: (params) => {
        let discount = sumDiscounts(params.row);
        return discount > 0 ? discount + "%" : "";
      },
    },
    {
      field: "unitPrice",
      className: "grid-header apeLigthBlueBackground",
      width: 180,
      renderHeader: () => intl.formatMessage({ id: "General.TotalPrice" }),
      renderCell: (params) => {
        let discount = sumDiscounts(params.row);
        let totQty = params.row.sizeAndQuantities
          .map((x) => x.renderedQty)
          .reduce((acc, curr) => acc + curr, 0);

        let totPrice = params.row.unitPrice * totQty;
        if (discount > 0) {
          let discountTot = (totPrice * discount) / 100;
          totPrice -= discountTot;
        }
        return totPrice;
      },
    },
    {
      field: "customCode",
      className: "grid-header apeLigthBlueBackground",
      width: 220,
      renderHeader: () => intl.formatMessage({ id: "RAPreparing.CustomCode" }),
    },
    {
      field: "seasonCode",
      className: "grid-header apeLigthBlueBackground",
      width: 100,
      renderHeader: () => intl.formatMessage({ id: "General.Season" }),
      renderCell: (params) => {
        if (params.row.seasonCode != null && params.row.seasonYear != null) {
          return params.row.seasonCode + "/" + params.row.seasonYear;
        }
        return "";
      },
    },
    {
      field: "eventCode",
      className: "grid-header apeLigthBlueBackground",
      width: 100,
      renderHeader: () => intl.formatMessage({ id: "General.Event" }),
    },
  ];

  const sumDiscounts = (row) => {
    let discount = 0;
    if(row.financialDiscount !== undefined && row.financialDiscount !== null){
      discount += row.financialDiscount
    }
    if(row.customerDiscount !== undefined && row.customerDiscount !== null){
      discount += row.customerDiscount
    }
    if(row.goodsDiscount !== undefined && row.goodsDiscount !== null){
      discount += row.goodsDiscount
    }

    return discount;
  }

  function ShowQty(row) {
    var groupedSizes = [];

    row.sizeAndQuantities.reduce(function (res, value) {
      if (!res[value.sizeDescription]) {
        res[value.sizeDescription] = { value: value.sizeDescription, renderedQty: 0 };
        groupedSizes.push(res[value.sizeDescription]);
      }
      res[value.sizeDescription].renderedQty += value.renderedQty;
      return res;
    }, {});

    return (
      <>
        {groupedSizes.map((size, index) => (
          <Grid item key={index}>
            <SizeAndQty sizeDescription={size.value} renderedQty={size.renderedQty} isInEdit={false} defaultQty={true}/>
          </Grid>
        ))}
      </>
    );
  }


  //#region DeleteRa
  const handleDeleteRA = () => {
    var message = intl.formatMessage({ id: "General.ConfirmAction" });
    if (!window.confirm(message)) {
      return false;
    }
    axios
      .delete(`/creditnotereturnfiles/${idReturnFileHead}`)
      .then((response) => {
        setLoading(false);
        toast.success(intl.formatMessage({ id: "RAPreparing.DossierDeleted" }));
        navigate("/");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  }
  //#endRegion

  //#region Delete Selected rows
  const handleDeleteSelectedRows = () => {
    var rowsToDelete = selectedRows.flat();
    deleteRows(idReturnFileHead, rowsToDelete);
  }

  const deleteRows = (idReturnFileHead, idReturnFileRowList) => {
    axios
      .delete(`/creditnotereturnfiles/${idReturnFileHead}/deleteRows`, { data: idReturnFileRowList })
      .then((response) => {
        setLoading(false);
        toast.success(intl.formatMessage({ id: "RAPreparing.RowsDeleted" }));
        getDetails();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  }
  //#endRegion

   //#region TrecateWH
  // const [openModalTrecateWh, setOpenModalTrecateWh] = useState(false);
  // const handleOpenModalTrecateWh = () => setOpenModalTrecateWh(true);
  // const handleCloseModalTrecateWh = () => {
  //   setOpenModalTrecateWh(false);
  //   getDetails();
  // }

  //#endRegion

  //#region Created ReturnFiles
  const [openModalCreatedReturnFiles, setOpenModalCreatedReturnFiles] = useState(false);
  const [createdRFs, setCreatedRFs] = useState([]);

  const handleOpenModalCreatedReturnFiles = (data) => {
    setOpenModalCreatedReturnFiles(true)
    setCreatedRFs(data);
  };

  const handleCloseModalCreatedReturnFiles = () => setOpenModalCreatedReturnFiles(false);

  const handleCloseEditWHDestForRAList = () => {
    handleCloseModalCreatedReturnFiles();
    window.location.reload();
  }

  //#endRegion

  //#region Edit Size And Qty
  const [openEditSizeAndQtyModal, setOpenEditSizeAndQtyModal] = useState(false);
  const handleOpenEditSizeAndQtyModal = () => setOpenEditSizeAndQtyModal(true);
  const handleCloseEditSizeAndQtyModal = (action) => {
    setEditData(null); 
    setOpenEditSizeAndQtyModal(false) 
    if(action == 'search'){
      getDetails();
    }
  };

  const [editData, setEditData] = useState(null);

  const handleEdit = (idReturnFileRowList, idInvoiceHeader, invoiceRowNumber) => {
    setEditData({
      idReturnFileHead: idReturnFileHead,
      returnFileKey: detailsHeader?.returnFileKey,
      idReturnFileRowList: idReturnFileRowList,
      idInvoiceHeader: idInvoiceHeader,
      invoiceRowNumber: invoiceRowNumber
    });
  }

  useEffect(() => {
    if(editData !== null){
      handleOpenEditSizeAndQtyModal();
    }
  }, [editData])
  //#endregion

  useStreamState({ detailsHeader, idReturnFileHead, user, setState, intl });

  const getBoxInCount = () => {
    setLoading(true);
    axios
      .get(`/creditnotereturnfiles/${idReturnFileHead}/boxincount`)
      .then((response) => {
        setLoading(false);
        setBoxInCount(response.data)
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleCreateReturnFiles = async () => {
    var message = intl.formatMessage({ id: "General.Confirm" });
    if (!window.confirm(message)) {
      return false;
    }
    setLoading(true);
    let url = `/creditnotereturnfiles/${idReturnFileHead}/create`;
    axios
      .post(url)
      .then((response) => {
        setLoading(false);
        handleOpenModalCreatedReturnFiles(response.data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleAcceptStealthReturnFile = (e) => {
    setLoading(true);
    apiService.acceptReturnFile(
      idReturnFileHead,
      null,
      (response) => {
        setLoading(false);
        toast.success("Saved!");
        navigate(`${process.env.PUBLIC_URL}/RADetail/${idReturnFileHead}`);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  function ConditionalButton({ state }) {
    if (state == "Preparing" && !showRADetailsThresholdMessage) {
      if (isStealthFile) {
        return (
          <Button
            sx={{ color: "white" }}
            onClick={(e) => {
              handleAcceptStealthReturnFile();
            }}
            disableRipple={true}
          >
            [{intl.formatMessage({ id: "StateActions.Accept" })}]{" "}
          </Button>
        );
      } else {
        return (
          <Button
            sx={{ color: "white" }}
            onClick={(e) => {
              handleOpenModalAccept(e, idReturnFileHead);
            }}
            disableRipple={true}
            disabled={state != "Preparing" || showRADetailsThresholdMessage}
          >
            [{intl.formatMessage({ id: "StateActions.Accept" })}]{" "}
          </Button>
        );
      }
    } else if (state == "Initial") {
      return (
        <Button
          sx={{ color: "white" }}
          onClick={(e) => {
            handleCreateReturnFiles();
          }}
          disableRipple={true}
          disabled={state != "Initial"}
        >
          [{intl.formatMessage({ id: "StateActions.Create" })}]{" "}
        </Button>
      );
    }
    return null;
  }

const getIsStealthReturnFile = () => {
  setLoading(true);
  axios
    .get("/creditnotereturnfiles/" + idReturnFileHead + "/stealthfile")
    .then((response) => {
      setLoading(false);
      setIsStealthFile(response.data)
    })
    .catch((error) => {
      setLoading(false);
      handleError(error, intl);
    });
};

  return (
    <div>
      <ReturnFileHeader
        idReconditionType={detailsHeader?.idReconditionType}
        returnFileKey={detailsHeader?.returnFileKey}
        rfDate={detailsHeader?.rfDate}
        rfType={detailsHeader?.rfType}
        rfState={state?.rfState}
        reconditionTypeDescr={detailsHeader?.reconditionTypeDescr}
        ictReference={detailsHeader?.ictReference}
        invoiceNumber={detailsHeader?.invoiceNumber}
        saprso={detailsHeader?.saprso}
        sapInboundDelivery={detailsHeader?.sapInboundDelivery}
        totalPieces={detailsHeader?.totalPieces}
        idReturnFileHead={idReturnFileHead}
        callBackAftereChangeReconditionType={getDetails}
      />
      {showRADetailsThresholdMessage ? (
        <Box sx={{ mt: 1 }}>
          <RADetailsThresholdMessage />
        </Box>
      ) : (
        ""
      )}
      <Card sx={{ mt: 1 }} className="apeDarkGreyBackground" id="actionsTop">
        <Grid container>
          {detailsHeader != null && detailsHeader.rfSubType != "STH-FILE" ? (
            <Grid item xs="auto" textAlign="center">
              <Button
                sx={{ color: "white" }}
                onClick={(e) => {
                  handleOpenModalAdd(e);
                }}
                disableRipple={true}
              >
                [{intl.formatMessage({ id: "RAPreparing.Add" })}]{" "}
              </Button>
            </Grid>
          ) : (
            ""
          )}
          <div style={{ margin: "auto" }}></div>

          <Grid item xs="auto" textAlign="center">
            <Button
              sx={{ color: "white" }}
              onClick={(e) => {
                handleOpenModalAttachments(e, idReturnFileHead);
              }}
              disableRipple={true}
            >
              [{intl.formatMessage({ id: "RADetails.Attachments" })}]{" "}
            </Button>
          </Grid>
        </Grid>
      </Card>

      <Card
        sx={{
          mt: "5px",
          height: `${tableHeigth}px`,
          maxHeight: `${tableHeigth}px`,
          overflow: "auto",
        }}
      >
        {details.length > 0 ? (
          <ExpandableCustomTable
            id={"idReturnFileRowList"}
            columns={columns}
            rows={details}
            isEnabledSelection={true}
            defaultHeaderClass="apeLigthBlueBackground"
            OnChangeSelectedRows={handleChangeSelectedRowsOfTable}
            alwaysExpanded={false}
            renderExpanded={ShowQty}
            name={"preparingTable"}
            size={"medium"}
          />
        ) : (
          ""
        )}
      </Card>

      <Card sx={{ mt: 1 }} className="apeDarkGreyBackground" id="actionsBottom">
        <Grid container>
          {detailsHeader != null && detailsHeader.rfSubType != "STH-FILE" ? (
            <Grid item md="auto" xs="auto" textAlign="center">
              <Button
                sx={{ color: "white" }}
                onClick={handleDeleteSelectedRows}
                disableRipple={true}
              >
                [{intl.formatMessage({ id: "RAPreparing.DeleteSelectedRows" })}]{" "}
              </Button>
            </Grid>
          ) : (
            ""
          )}
          <div style={{ margin: "auto" }}></div>

          <Grid item xs="auto" textAlign="center">
            <Button
              sx={{ color: "white" }}
              onClick={handleDeleteRA}
              disableRipple={true}
            >
              [{intl.formatMessage({ id: "RAPreparing.DeleteDossier" })}]{" "}
            </Button>
          </Grid>
          <Grid item xs="auto" textAlign="center">
            <ConditionalButton state={detailsHeader?.rfStateCode} />
          </Grid>
        </Grid>
      </Card>

      <AttachmentModal
        openModal={openModalAttachments}
        handleCloseModal={handleCloseModalAttachments}
        idReturnFileHead={idReturnFileHead}
      />

      <AddModal
        openModal={openModalAdd}
        handleCloseModal={handleCloseModalAdd}
        modalHeaderText={detailsHeader?.returnFileKey}
        idReturnFileHead={idReturnFileHead}
      />

      <AcceptModal
        openModal={openModalAccept}
        handleCloseModal={handleCloseModalAccept}
        modalHeaderText={detailsHeader?.returnFileKey}
        idReturnFileHead={idReturnFileHead}
        boxInCount={boxInCount}
      />

      <Modal
        open={openModalCreatedReturnFiles}
        onClose={handleCloseModalCreatedReturnFiles}
      >
        <Box sx={modalStyle}>
          <EditWarehouseDestinationsForRAList
            ids={createdRFs}
            handleSave={handleCloseEditWHDestForRAList}
          />
        </Box>
      </Modal>

      {editData !== null ? (
        <EditSizesAndQtyModal
          openModal={openEditSizeAndQtyModal}
          handleCloseModal={handleCloseEditSizeAndQtyModal}
          editData={editData}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default RAPreparing;